// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3154de31","455":"5b7778f9","977":"d4fbbbfe"}[chunkId] + ".chunk.js";
};